module.exports = __webpack_public_path__ + "img/help-center.cfc6c3ca.svg";